import confetti from "canvas-confetti";

// The "school pride" effect from the canvas-confetti demos: two low cannons
// firing continuously from the left and right edges. Colored with our three
// decorative accents — never the text colors (see PALETTE.md).
const COLORS = ["#006981", "#839958", "#d38c97"]; // midnight-teal, sage-moss, dusty-rose
const DURATION_MS = 4000;

// Must stay a multiple of COLORS.length. canvas-confetti assigns colors by
// index, not at random (`colors[temp % colors.length]`, counting down from
// particleCount) — so a count below the number of colors silently drops the
// tail of the array. The original demo's 2 works only because it has 2 colors.
const PARTICLES_PER_FRAME = COLORS.length;

/**
 * Fires the cannons for `durationMs`. Returns a cancel function — call it on
 * unmount so the loop doesn't outlive the view that started it.
 */
export function schoolPride(durationMs: number = DURATION_MS): () => void {
  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
    return () => {};
  }

  const end = Date.now() + durationMs;
  let frame = 0;

  const tick = () => {
    confetti({
      particleCount: PARTICLES_PER_FRAME,
      angle: 60,
      spread: 55,
      origin: { x: 0 },
      colors: COLORS,
    });
    confetti({
      particleCount: PARTICLES_PER_FRAME,
      angle: 120,
      spread: 55,
      origin: { x: 1 },
      colors: COLORS,
    });
    if (Date.now() < end) frame = requestAnimationFrame(tick);
  };
  tick();

  return () => {
    cancelAnimationFrame(frame);
    confetti.reset();
  };
}
